"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _withStyles = _interopRequireDefault(require("../styles/withStyles"));

var _common = _interopRequireDefault(require("../colors/common"));

var styles = function styles(theme) {
  return {
    tooltip: {
      '&::after': {
        content: '""',
        display: 'none',
        position: 'absolute',
        borderLeft: '7px solid transparent',
        borderRight: '7px solid transparent',
        borderBottom: "7px solid ".concat(theme.palette.grey[700])
      }
    },
    light: {
      backgroundColor: _common.default.white,
      color: _common.default.black,
      '&::after': {
        borderBottom: "7px solid ".concat(_common.default.white)
      }
    },
    tooltipPlacementTop: {
      '&::after': {
        display: 'block',
        transform: 'translate(-50%, -1px) rotate(180deg)',
        bottom: '-7px',
        left: '50%'
      }
    },
    tooltipPlacementLeft: {
      '&::after': {
        display: 'block',
        transform: 'translate(-50%, -1px) rotate(90deg)',
        top: '8px',
        right: '-15px'
      }
    },
    tooltipPlacementBottom: {
      '&::after': {
        display: 'block',
        transform: 'translate(-50%, -1px)',
        top: '-5px',
        left: '50%'
      }
    },
    tooltipPlacementRight: {
      '&::after': {
        display: 'block',
        transform: 'translate(-50%, -1px) rotate(-90deg)',
        top: '8px',
        left: '-1px'
      }
    }
  };
};

function TooltipWithCaret(props) {
  var classes = props.classes,
      children = props.children,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children"]);
  return _react.default.createElement(_Tooltip.default, (0, _extends2.default)({
    classes: {
      tooltip: (0, _classnames.default)(classes.tooltip, props.light && classes.light),
      tooltipPlacementRight: classes.tooltipPlacementRight,
      tooltipPlacementTop: classes.tooltipPlacementTop,
      tooltipPlacementLeft: classes.tooltipPlacementLeft,
      tooltipPlacementBottom: classes.tooltipPlacementBottom
    }
  }, other), children);
}

process.env.NODE_ENV !== "production" ? TooltipWithCaret.propTypes = {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Prop used for changing the tooltip to have a white-background, black-text theme
   */
  light: _propTypes.default.bool,

  /**
   * Tooltip placement
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
} : void 0;
TooltipWithCaret.defaultProps = {
  placement: 'bottom',
  light: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltipWithCaret',
  withTheme: true
})(TooltipWithCaret);

exports.default = _default;